import SmartFeedOptions from "%/dynamic-component-editor/bundles/smart-feed-options";
import SmartFeedCardLayout from "%/dynamic-component-editor/options/smart-feed-card-layout";
import SmartFeedLayout from "%/dynamic-component-editor/options/smart-feed-layout";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";

export const SmartFeedElementMixin = {
  elementPanelSettings: {
    displayIcon: "message",
    elementType: "element",
  },
  optionBundles: [SmartFeedOptions],
  options: [],
  data() {
    return {
      SmartFeedLayout,
      SmartFeedCardLayout,
      EmptyStateText,
    };
  },
};
